import GoFetch from '~/js/modules/fetch-wrapper';
import roomsFilter from '~/js/modules/roomsFilter';
import listGridViewer from '../seb/includes/list-grid-viewer';
import RoomsSuitesContainer from './rooms-suites/RoomsSuitesContainer';
import Tabs from './rooms-suites/Tabs';
import FeaturePopovers from './rooms-suites/FeaturePopovers';
import ModalInformation from './rooms-suites/ModalInfo';
import CardSkeleton from './rooms-suites/CardSkeleton';
import modal from '~/js/modules/magnific-popup';

const { Fragment } = window.React;
const fetch = new GoFetch();

class Accomodations extends React.Component {
    constructor(props) {
        super(props);

        this._bind(
            'getRooms',
            'filterByRoomType',
            'filterByRoomCategoryCode',
            'toggleGridView',
            'updateFilters',
            'triggerFilters'
        );

        this.state = {
            status: 'loading',
            rooms: [],
            filteredRooms: [],
            minimumRates: {},
            isGrid: true,
            filters: {
                roomType: this.props.filters.roomType || 'ALL'
            },
            averageRate: 0,
            hasBeenScrolled: false
        };

    }

    componentDidMount() {
        this.getRooms();
    }

    toggleGridView(isGrid) {
        this.setState({ isGrid }, () => {
            if (!isGrid) {
                modal();
            }
        });
    }

    refReference = refElement => {
        if (this.state.hasBeenScrolled === false) {
            this.setState({ hasBeenScrolled: true }, () => {
                window.scroll({
                    top: refElement.current.offsetTop - 150,
                    behavior: 'smooth'
                });
            });
        }
    };

    getRooms() {
        const url = '/loadRoomData/';
        const parameters = {
            resortCode: this.props.resortCode
        };

        fetch.post(url, null, parameters).then(response => {
            const { status = 'error', data = {} } = response;

            if (status === 'success') {
                const { rooms = [], rates: minimumRates = {} } = data;
                const { roomCategories = [] } = this.props.filters;

                let filteredRooms;
                let averageRate;

                if (roomCategories.length > 0) {
                    filteredRooms = this.filterByRoomCategoryCode(rooms);

                    averageRate = this.getMinimumRates(filteredRooms);
                } else {
                    filteredRooms = rooms;

                    averageRate = this.getAverageRate(minimumRates);
                }

                this.setState(
                    {
                        rooms: filteredRooms,
                        filteredRooms: [...filteredRooms],
                        status,
                        averageRate
                    },
                    this.roomsDidMount
                );
            } else {
                this.setState({ status: 'error' });
            }
        });
    }

    roomsDidMount() {
        listGridViewer();
        roomsFilter();
        modal();
        this.triggerFilters();
    }

    getMinimumRates(rooms = []) {
        let butlerRate = null;
        let clubRate = null;
        let luxuryRate = null;
        let loveNestRate = null;
        let lowestRate = null;

        for (let index = 0; index < rooms.length; index++) {
            const room = rooms[index];
            const rate = room.rate.avgRate;
            const nextRoom = rooms[index + 1];

            if (
                nextRoom &&
                (lowestRate < nextRoom.rate.avgRate || lowestRate === null)
            ) {
                lowestRate = nextRoom.rate.avgRate;
            }

            if (room.loveNest && loveNestRate < rate) {
                loveNestRate = rate;
            }

            if (
                room.roomType === 'BUTLER' &&
                (butlerRate < rate || lowestRate === null)
            ) {
                butlerRate = rate;
            }

            if (
                room.roomType === 'CLUB' &&
                (clubRate < rate || lowestRate === null)
            ) {
                clubRate = rate;
            }

            if (
                room.roomType === 'LUXURY' &&
                (luxuryRate < rate || lowestRate === null)
            ) {
                luxuryRate = rate;
            }
        }

        return {
            lowestRate,
            loveNestRate,
            butlerRate,
            clubRate,
            luxuryRate
        };
    }

    getAverageRate(minimumRates) {
        const {
            BUTLER = {},
            CLUB = {},
            LUXURY = {},
            loveNest = {},
            lowest = {}
        } = minimumRates;

        const butlerRate = BUTLER.avgRate || 0;
        const clubRate = CLUB.avgRate || 0;
        const luxuryRate = LUXURY.avgRate || 0;
        const loveNestRate = loveNest.avgRate || 0;
        const lowestRate = lowest.avgRate || 0;

        return {
            butlerRate,
            clubRate,
            luxuryRate,
            loveNestRate,
            lowestRate
        };
    }

    filterByRoomCategoryCode(rooms) {
        const { roomCategories = [] } = this.props.filters;

        return roomCategories.length > 0
            ? rooms.filter(room =>
                  roomCategories.includes(room.roomCategoryCode)
              )
            : rooms;
    }

    filterByRoomType(rooms) {
        const { roomType } = this.state.filters;

        if (roomType === 'ALL') {
            return rooms;
        }

        if (roomType === 'LOVENEST') {
            return rooms.filter(room => room.features.includes('Love Nest'));
        }

        return rooms.filter(room => room.roomType === roomType);
    }

    orderByRates(rooms = []) {
        return rooms.sort((a, b) => {
            const { rate: rateA = {} } = a;
            const { rate: rateB = {} } = b;

            const { avgRate: avgRateA = 0 } = rateA;
            const { avgRate: avgRateB = 0 } = rateB;

            return avgRateB - avgRateA;
        });
    }

    updateFilters(newFilters) {
        const { ...filters } = newFilters;

        this.setState({ filters }, this.triggerFilters);
    }

    triggerFilters() {
        const [...rooms] = this.state.rooms;
        const filters = {
            roomType: this.filterByRoomType,
            orderByRates: this.orderByRates
        };

        let filteredRooms = null;

        const applyTheseFilters = ['roomType', 'orderByRates'];

        filteredRooms = applyTheseFilters.reduce((acc, value) => {
            return this.applyFilter(filters, value, acc);
        }, rooms);

        this.setState({ filteredRooms });
    }

    applyFilter(filters, value, rooms) {
        return filters[value](rooms);
    }

    render() {
        const { resortCode, uris = {} } = this.props;
        const { roomType } = this.props.filters;
        const {
            filteredRooms = [],
            isGrid,
            averageRate,
            status,
            filters
        } = this.state;
        const isTransfer = window.location.pathname === '/luxury-transfers/';
        let roomLevel = '';

        if (this.props.roomLevel) {
            roomLevel = this.props.roomLevel;
        } else if (isTransfer) {
            roomLevel = ' ';
        } else if (roomType) {
            roomLevel = `Under ${roomType} Level`;
        }

        return (
            <Fragment>
                {this.props.hasTabs && (
                    <div className="container">
                        <div className="rooms-suites">
                            <Tabs
                                className={'position-static txt-center'}
                                averageRate={averageRate}
                                status={status}
                                filters={filters}
                                updateFilters={this.updateFilters}
                            />
                        </div>
                    </div>
                )}

                {
                    {
                        loading: (
                            <div key="si1" className="list-grid-viewer-section">
                                <div className="container">
                                    <div className="row">
                                        <CardSkeleton />
                                        <CardSkeleton />
                                        <CardSkeleton />
                                    </div>
                                </div>
                            </div>
                        ),
                        error: (
                            <h5 key="si3" className="txt-center">
                                Opss! Something Went Wrong!
                            </h5>
                        ),
                        success: (
                            <div className="list-grid-viewer-section cs-list-grid-viewer to-scroll-viewer">
                                <div className="container">
                                    <ModalInformation />

                                    <FeaturePopovers />

                                    <RoomsSuitesContainer
                                        roomsFound={filteredRooms.length}
                                        refReference={this.refReference}
                                        roomLevel={roomLevel}
                                        rooms={filteredRooms}
                                        resortCode={resortCode}
                                        uris={uris}
                                        isGrid={isGrid}
                                        toggleGridView={this.toggleGridView}
                                        hideRefine
                                    />
                                </div>
                            </div>
                        )
                    }[status]
                }
            </Fragment>
        );
    }
}

Accomodations.defaultProps = {
    resortCode: window.sandals_app.page.resortCode || '',
    uris: window.sandals_app.page.uris || {},
    hasTabs: false
};

export default Accomodations;
